import { render, staticRenderFns } from "./KyivRegionCf.vue?vue&type=template&id=03abfb12"
import script from "./KyivRegionCf.vue?vue&type=script&lang=js"
export * from "./KyivRegionCf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports